export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  count: number;
  description: string;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "热血",
    slug: "rexue",
    icon: "ri-fire-line",
    count: 3250,
    description: "热血战斗类韩漫，包含升级打怪、武道修炼等激励人心的作品，点燃你的斗志"
  },
  {
    id: "cat-2",
    name: "恋爱",
    slug: "lianai",
    icon: "ri-heart-line",
    count: 4180,
    description: "浪漫恋爱类韩漫，从校园纯爱到都市恋情，感受心动的每一个瞬间"
  },
  {
    id: "cat-3",
    name: "奇幻",
    slug: "qihuan",
    icon: "ri-magic-line",
    count: 2960,
    description: "奇幻冒险类韩漫，穿越异世界、魔法与剑、神话传说，开启无限的想象力之旅"
  },
  {
    id: "cat-4",
    name: "悬疑",
    slug: "xuanyi",
    icon: "ri-search-eye-line",
    count: 1870,
    description: "悬疑推理类韩漫，环环相扣的谜题与惊心动魄的剧情，考验你的推理能力"
  },
  {
    id: "cat-5",
    name: "搞笑",
    slug: "gaoxiao",
    icon: "ri-emotion-laugh-line",
    count: 2540,
    description: "搞笑日常类韩漫，轻松幽默的剧情让你开怀大笑，缓解一天的疲惫"
  },
  {
    id: "cat-6",
    name: "动作",
    slug: "dongzuo",
    icon: "ri-shield-flash-line",
    count: 2130,
    description: "动作格斗类韩漫，拳拳到肉的战斗场面，酣畅淋漓的动作盛宴"
  },
  {
    id: "cat-7",
    name: "校园",
    slug: "xiaoyuan",
    icon: "ri-building-line",
    count: 3620,
    description: "校园生活类韩漫，青春岁月的欢笑与泪水，记录最美的校园时光"
  },
  {
    id: "cat-8",
    name: "都市",
    slug: "dushi",
    icon: "ri-building-2-line",
    count: 2890,
    description: "都市题材类韩漫，在繁华都市中上演的人生百态与职场传奇"
  }
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find(cat => cat.slug === slug);
};